var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-icon",class:_vm.cssClassWrapper,on:{"click":_vm.onClick}},[_c('i',{class:_vm.cssClass},[_vm._v(_vm._s(_vm.sourceOptions.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }